import { store } from "@/store/store";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import { alegaciones_lote } from "@/shared/dtos/alegaciones_lote";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import usuarioModule from "./usuario-module";

@Module({
  namespaced: true,
  name: "alegaciones_loteModule",
  store,
  dynamic: true,
})
class alegaciones_loteModule extends VuexModule {
  public lotes: alegaciones_lote[] = [];
  public lote: alegaciones_lote = new alegaciones_lote();
  public mis_alegaciones_pendientes: alegaciones_lote[] = [];

  // Obtener lotes por usuario
  @Action({ commit: "onGetLotes" })
  public async getLotesByUsuario(id_usuario: number) {
    return await ssmHttpService.get(
      API.alegaciones_lote + "/usuario/" + id_usuario
    );
  }

  // Obtener un lote por id
  @Action({ commit: "onGetLote" })
  public async getLote(id: number) {
    return await ssmHttpService.get(API.alegaciones_lote + "/" + id);
  }

  @Action({ commit: "onGetMisAlegacionesPendientes" })
  public async getAlegacionPendientes() {
    return await ssmHttpService.get(
      API.alegaciones_lote + "/pendientes/" + usuarioModule.mi_usuario.id
    );
  }

  // Obtener un lote por token (enlace del email)
  @Action({ commit: "onGetLote" })
  public async getLoteByToken(token: string) {
    return await ssmHttpService.get(
      API.alegaciones_lote + "/by-token/" + token
    );
  }
  @Action({})
  public async sendEmailByIdLote(id: number) {
    return await ssmHttpService.get(API.alegaciones_lote + "/send-email/" + id);
  }

  // Crear lote
  @Action
  public async crearLote(model: alegaciones_lote) {
    return await ssmHttpService.post(API.alegaciones_lote, model.toJson());
  }

  // Modificar lote
  @Action
  public async modificarLote(model: alegaciones_lote) {
    return await ssmHttpService.put(
      API.alegaciones_lote + "/" + model.id,
      model
    );
  }

  // Eliminar lote
  @Action
  public async eliminarLote(model: alegaciones_lote) {
    return await ssmHttpService.delete(
      API.alegaciones_lote + "/" + model.id,
      null,
      false
    );
  }

  // Mutaciones
  @Mutation
  public onGetLotes(res: alegaciones_lote[]) {
    this.lotes = res
      ? res.map(function(x) {
          return new alegaciones_lote(x);
        })
      : [];
  }
  @Mutation
  public onGetMisAlegacionesPendientes(res: alegaciones_lote[]) {
    this.mis_alegaciones_pendientes = res
      ? res.map(function(x) {
          return new alegaciones_lote(x);
        })
      : [];
  }
  @Mutation
  public onGetLote(res: alegaciones_lote) {
    this.lote = new alegaciones_lote(res);
  }
}

export default getModule(alegaciones_loteModule);
